import { countries } from '@/constants';
import { FormField, ErrorMode } from '@/models';
import { CountryCode } from '@/store/ui';
import moment from 'moment';

export function isValidPhoneNumber(number: string): boolean {
  const sanitizedPhoneNumber = number.replace(/[\(\) -]/g, '');
  return /^[0-9]{10,11}$/.test(sanitizedPhoneNumber);
}

export function isValidEmail(email: string): boolean {
  // https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s01.html
  // Regex from above, and added restrictions to follow CrowdTwist validation rules
  // https://docs.oracle.com/en/cloud/saas/marketing/crowdtwist-develop/Developers/UserFormattingRules.html

  if  (/^[\w%+-]+(?:\.[\w%+-]+)*@(?:[A-Z0-9][A-Z0-9-]+\.)+([A-Z]){2,6}$/i.test(email)) {
    // Verify top-level domain doesn't repeat
    var hostname = email.split('@');
    var domains = hostname[1].split('.');
    return domains[domains.length - 1] !== domains[domains.length - 2];
  }

  return false;
}

export function isValidPostalCode(postalCode: string, countryCode: string = CountryCode.US): boolean {
  return countries[countryCode.toLowerCase()]
    .validations.zipCode.formatRegex.test(postalCode);
}

export function isValidCanadaPostalCode(postalCode: string): boolean {
  return /^[\da-zA-Z]{6}$/.test(postalCode);
}

// Validating MMDD
export function isValidBirthday(birthday: string): boolean {
  // hardcoding 2020 as year because it is a leap year so it will accept february 29
  return moment(`${birthday}2020`, 'MMDDYYYY').isValid();
}

export function enforceMaxLength(value: string, validLengths: number[], formField: FormField): string {
  if (validLengths.includes(value.length)) {
    formField.dirty = true;
  }

  return value.slice(0, Math.max(...validLengths));
}

export function validatePassword(password: FormField): void {
  if (!password || !password.value || password.value.length == 0) {
    password.error = 'Password Required';
  } else {
    password.error = !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#\\$%&'()*+,-.:;<=>?@[\]\^_`{|}~])(?=.{8,50}$)/.test(password.value)
      ? 'Please Enter A Valid Password'
      : '';
  }

  password.errorMode = ErrorMode.PlaceHolder;
}

/** Names can contain letters, spaces, apostrophes, underscores and hyphens */
export function isValidCustomerName(name: string): boolean {
  return /^[A-Za-z '_-]+$/.test(name);
}


/**function to check for strings of >12 digits in input and truncates that value to 12 */
export function removeLargeNumbers(input: string) {
  let array = input.split(" "); 
   array.forEach((element, index, arr) => {
    if (element.length > 12 && /^\d+$/.test(element)) {
        arr[index] = element.slice(0,12);
    }
  });
  return array.join(' ');
  }